import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgStars3 = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.666 3.42a.75.75 0 0 0-1.348.003L10.183 5.77H7.959a.75.75 0 0 0-.545 1.265L9.18 8.902l-.471 2.688a.75.75 0 0 0 1.125.772L12 11.06l2.282 1.31a.75.75 0 0 0 1.108-.804l-.56-2.676 1.755-1.856a.75.75 0 0 0-.545-1.265h-2.226zm-1.338 3.425.668-1.38.677 1.383a.75.75 0 0 0 .674.42h.953l-.828.877a.75.75 0 0 0-.19.669l.298 1.422-1.214-.697a.75.75 0 0 0-.76.008l-1.136.683.252-1.44a.75.75 0 0 0-.194-.645L9.7 7.269h.953a.75.75 0 0 0 .675-.424m-4.546 4.186a.75.75 0 0 1 .675.42l1.149 2.348h2.226a.75.75 0 0 1 .545 1.265l-1.755 1.857.56 2.675a.75.75 0 0 1-1.108.804l-2.282-1.31-2.167 1.303A.75.75 0 0 1 3.5 19.62l.47-2.689-1.765-1.868A.75.75 0 0 1 2.75 13.8h2.224l1.134-2.345a.75.75 0 0 1 .674-.423m.005 2.464-.668 1.38a.75.75 0 0 1-.675.424H4.49l.828.877a.75.75 0 0 1 .194.644l-.252 1.44 1.136-.683a.75.75 0 0 1 .76-.007l1.214.697-.298-1.423a.75.75 0 0 1 .19-.669l.828-.876h-.953a.75.75 0 0 1-.674-.42zM17.2 11.031a.75.75 0 0 1 .676.42l1.148 2.348h2.226a.75.75 0 0 1 .545 1.265l-1.755 1.857.56 2.675a.75.75 0 0 1-1.108.804l-2.282-1.31-2.167 1.303a.75.75 0 0 1-1.125-.772l.47-2.689-1.765-1.868a.75.75 0 0 1 .546-1.265h2.223l1.135-2.345a.75.75 0 0 1 .673-.423m.006 2.464-.668 1.38a.75.75 0 0 1-.676.424h-.953l.829.877a.75.75 0 0 1 .193.644l-.252 1.44 1.136-.683a.75.75 0 0 1 .76-.007l1.215.697-.298-1.423a.75.75 0 0 1 .189-.669l.828-.876h-.953a.75.75 0 0 1-.674-.42z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgStars3;
